export default {
    common: {
        title: "Modifica immagine",
        cancel: "Cancella",
        save: "Salva",
        crop: "Raccolto",
        adjustments: "Regolazioni",
        filters: "Filtri",
        frames: "Cornici",
        overlays: "Sovrapposizioni",
        text: "Testo",
        stickers: "Adesivi",
        brush: "Spazzola",
        ai: "Crea immagine usando l'IA",
        reset: "Ripristino",
        comingSoon: 'Prossimamente...',
    },
};
